import { render, staticRenderFns } from "./popup-do.vue?vue&type=template&id=20956fa0&scoped=true"
import script from "./popup-do.vue?vue&type=script&lang=js"
export * from "./popup-do.vue?vue&type=script&lang=js"
import style0 from "./popup-do.vue?vue&type=style&index=0&id=20956fa0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20956fa0",
  null
  
)

export default component.exports